import {createAction} from '@reduxjs/toolkit'

export const resetProcessStatus = createAction('shoppingSubscription/resetProcessStatus')
